import { useDroppable } from '@dnd-kit/core';
import { useMemo } from 'react';
import { groupTileInput } from '@utils/component-framework';
import { useOpgavekompleksetEntry } from '../../../../state/hook.entry.js';
import { useTaskContext } from '../../context.js';
import { DraggableTile } from './atom.draggable.js';
import { GroupTile } from './atom.tile.js';
import { drawer, label } from './molecule.drawer.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TileDrawer(props) {
  const context = useTaskContext();
  const {
    setNodeRef
  } = useDroppable({
    id: "drawer",
    disabled: !props.draggable
  });
  const placedTileIds = useOpgavekompleksetEntry({
    select: entry => Object.entries(entry?.data.tasks[props.taskEntryKey]?.details ?? {}).filter(([, value]) => !!groupTileInput.entry.asTypeSafe(value)).map(([key]) => key)
  });
  const sortedTiles = useMemo(() => {
    const tiles = props.tiles.filter(it => !it.options.fixed);
    if (context !== "input") {
      return tiles;
    }
    return [...tiles].sort((a, b) => {
      const isAPlaced = placedTileIds?.some(id => id === a.id);
      const isBPlaced = placedTileIds?.some(id => id === b.id);
      if (isAPlaced) {
        return 1;
      }
      if (isBPlaced) {
        return -1;
      }
      return 0;
    });
  }, [context, placedTileIds, props.tiles]);
  return /*#__PURE__*/jsxs("div", {
    className: drawer,
    "data-type": props.type,
    ref: setNodeRef,
    children: [/*#__PURE__*/jsxs("span", {
      className: label,
      children: [sortedTiles.length, " brik", sortedTiles.length !== 1 ? "ker" : ""]
    }), sortedTiles.map(tile => props.draggable ? /*#__PURE__*/jsx(DraggableTile, {
      tile: tile,
      context: "drawer",
      taskEntryKey: props.taskEntryKey,
      isDraggingItem: tile.id === props.draggedTileId
    }, tile.id) : /*#__PURE__*/jsx(GroupTile, {
      taskEntryKey: props.taskEntryKey,
      context: "drawer",
      state: "placed",
      tile: tile
    }, tile.id))]
  });
}

export { TileDrawer };
//# sourceMappingURL=molecule.drawer.js.map
